const p = (subject, detail) => ({ subject, detail });
const sideLabel = (title, hint, shots) => ({
    title,
    hint,
    instruction: [
        p('Крылья и двери', 'зазоры, разнотон'),
        p('Порог и арки', 'коррозия'),
        p('Зеркало', 'сколы, складывание'),
    ],
    shots,
});
export const STEP_LABELS_RU = {
    conditions: {
        title: 'Условия',
        hint: 'Три тапа — свет, погода, кузов',
        instruction: [
            p('Свет', 'день, сумерки, темно или под крышей'),
            p('Погода', 'сухо, дождь, снег, мороз'),
            p('Кузов', 'чистый, пыльный, грязный, мокрый'),
        ],
    },
    engine_parking: {
        title: 'Двигатель и стоянка',
        hint: 'до пуска — ладонь на капот, взгляд под машину',
        instruction: [
            p('Капот', 'тёплый — мотор недавно заводили'),
            p('Место стоянки', 'свежие капли масла, антифриза'),
            p('Под бампером', 'подтёки, мокрые пятна'),
        ],
        shots: ['место под мотором'],
    },
    overview: {
        title: 'Общий вид',
        hint: 'отойдите на 4–5 м по диагонали',
        instruction: [
            p('Посадка', 'ровная, без перекоса'),
            p('Цвет', 'одинаковый на всех деталях'),
            p('Комплектация', 'совпадает с объявлением'),
        ],
        shots: ['спереди, три четверти', 'сзади, три четверти'],
    },
    vin_plate: {
        title: 'VIN и табличка',
        hint: 'VIN — под лобовым, на стойке или под капотом',
        instruction: [
            p('VIN на кузове', 'читается, не перебит'),
            p('Табличка', 'на месте, заклёпки родные'),
            p('Сверка', 'совпадает с объявлением'),
        ],
        shots: ['VIN на кузове', 'табличка'],
    },
    techpassport_keys: {
        title: 'Техпаспорт и ключи',
        hint: 'фото увидите только вы — клиенту уйдут выводы',
        instruction: [
            p('VIN в техпаспорте', 'совпадает с кузовом'),
            p('Владельцы', 'сколько по документу'),
            p('Ключи и история', 'сколько ключей, сервисная книжка'),
        ],
        shots: ['техпаспорт', 'ключи'],
    },
    dashboard: {
        title: 'Приборы, одометр',
        hint: 'зажигание включено, мотор не заведён',
        instruction: [
            p('Контрольные лампы', 'загораются и гаснут'),
            p('Одометр', 'сверьте с объявлением'),
            p('Стрелки и экран', 'всё работает'),
        ],
        shots: ['приборная панель'],
    },
    cold_start: {
        title: 'Холодный пуск',
        hint: 'у открытого капота',
        say: 'Попросите продавца завести. Снимайте моторный отсек, 15 с',
        instruction: [
            p('Первые секунды', 'стук, звон'),
            p('Под капотом', 'дым, запах'),
            p('Обороты', 'ровные, без провалов'),
        ],
    },
    exhaust: {
        title: 'Выхлоп',
        hint: 'сзади, у трубы, мотор работает',
        say: 'Попросите продавца дважды плавно поднять обороты',
        instruction: [
            p('Цвет дыма', 'сизый, белый, чёрный'),
            p('Звук', 'ровный, без хлопков'),
            p('Труба', 'без прогара и масляной копоти'),
        ],
    },
    body_front: {
        title: 'Передняя часть',
        hint: 'встаньте спереди, в 2–3 м',
        instruction: [
            p('Капот и бампер', 'зазоры, разнотон'),
            p('Кромка капота', 'сколы, перекрас'),
            p('Фары', 'одинаково мутные — родные'),
        ],
        shots: ['перёд целиком', 'вдоль капота'],
    },
    body_left: sideLabel('Левый бок', 'встаньте слева, в 2–3 м', ['весь борт', 'вдоль борта']),
    body_rear: {
        title: 'Задняя часть',
        hint: 'встаньте сзади, в 2–3 м',
        instruction: [
            p('Крышка багажника и бампер', 'зазоры, разнотон'),
            p('Задние крылья', 'перекрас, шпатлёвка'),
            p('Фонари', 'одинаковые, без трещин'),
        ],
        shots: ['зад целиком', 'вдоль крышки багажника'],
    },
    body_right: sideLabel('Правый бок', 'встаньте справа, в 2–3 м', ['весь борт', 'вдоль борта']),
    roof: {
        title: 'Крыша',
        hint: 'с порога или с подножки',
        instruction: [
            p('Панель крыши', 'вмятины, град'),
            p('Стойки', 'перекрас, следы правки'),
            p('Люк и рейлинги', 'уплотнители, коррозия'),
        ],
        shots: ['крыша'],
    },
    glass: {
        title: 'Стёкла',
        hint: 'маркировка — в углу каждого стекла',
        instruction: [
            p('Лобовое', 'трещины, сколы в зоне водителя'),
            p('Маркировка', 'один год на всех стёклах'),
            p('Боковые и заднее', 'целые, родные'),
        ],
        shots: ['маркировка лобового'],
    },
    lights: {
        title: 'Свет',
        hint: 'габариты, ближний, стоп и поворотники',
        instruction: [
            p('Фары', 'горят обе, одинаковый цвет'),
            p('Фонари и стоп', 'светит всё'),
            p('Стёкла фар', 'трещины, запотевание'),
        ],
        shots: ['перёд со светом', 'зад со светом'],
    },
    engine_bay: {
        title: 'Моторный отсек',
        hint: 'капот открыт, мотор заглушен',
        instruction: [
            p('Лонжероны и чашки', 'сварка, следы стапеля'),
            p('Мотор и шланги', 'подтёки масла, антифриза'),
            p('Проводка', 'скрутки, погрызы'),
        ],
        shots: ['моторный отсек целиком', 'лонжероны и чашки'],
    },
    trunk: {
        title: 'Багажник',
        hint: 'поднимите пол багажника',
        instruction: [
            p('Пол и ниша запаски', 'сварка, вода, коррозия'),
            p('Задняя панель', 'следы правки'),
            p('Комплект', 'запаска, домкрат, знак'),
        ],
        shots: ['багажник', 'ниша запаски'],
    },
    door_openings: {
        title: 'Проёмы',
        hint: 'откройте все двери',
        instruction: [
            p('Стойки и пороги', 'сварка, шпатлёвка'),
            p('Уплотнители', 'опыл краски'),
            p('Петли и болты', 'откручивали — дверь снимали'),
        ],
        shots: ['левые проёмы', 'правые проёмы'],
    },
    wheels_front: {
        title: 'Передние колёса',
        hint: 'выверните руль — будет виден протектор',
        instruction: [
            p('Протектор', 'глубина на каждом колесе'),
            p('Шины', 'год по DOT, грыжи, порезы'),
            p('Диски', 'удары, трещины'),
        ],
        shots: ['левое переднее', 'правое переднее'],
    },
    wheels_rear: {
        title: 'Задние колёса',
        hint: 'присядьте у каждого колеса',
        instruction: [
            p('Протектор', 'глубина на каждом колесе'),
            p('Шины', 'год по DOT, грыжи, порезы'),
            p('Диски', 'удары, трещины'),
        ],
        shots: ['левое заднее', 'правое заднее'],
    },
    brakes: {
        title: 'Тормоза',
        hint: 'через спицы диска',
        instruction: [
            p('Диски', 'борт, выработка, ржавчина'),
            p('Колодки', 'остаток накладки'),
            p('Суппорты', 'подтёки, пыльники'),
        ],
        shots: ['тормозной диск'],
    },
    interior_wear: {
        title: 'Износ',
        hint: 'сядьте на место водителя',
        instruction: [
            p('Руль, рычаг, педали', 'износ по пробегу'),
            p('Сиденье водителя', 'боковина, продавы'),
            p('Запах', 'курение, сырость'),
        ],
        shots: ['место водителя', 'руль и рычаг'],
    },
    moisture: {
        title: 'Влага',
        hint: 'поднимите коврики',
        instruction: [
            p('Под ковриками', 'сырость, грязь'),
            p('Ковёр и пол', 'следы воды, ил'),
            p('Запах', 'плесень, затхлость'),
        ],
        shots: ['пол у водителя'],
    },
    airbags: {
        title: 'Подушки',
        hint: 'включите зажигание',
        instruction: [
            p('Лампа SRS', 'гаснет через пару секунд'),
            p('Руль и панель', 'швы, следы вскрытия'),
            p('Ремни', 'вытягиваются и фиксируются'),
        ],
        shots: ['руль и торпедо'],
    },
    electrics: {
        title: 'Электрика',
        hint: 'зажигание включено',
        instruction: [
            p('Стеклоподъёмники и замки', 'все работают'),
            p('Зеркала и сиденья', 'регулировки'),
            p('Мультимедиа', 'экран, звук, камера'),
        ],
        shots: ['экран мультимедиа'],
    },
    climate: {
        title: 'Климат',
        hint: 'мотор работает',
        instruction: [
            p('Кондиционер', 'холодит, компрессор включается'),
            p('Печка', 'греет на всех режимах'),
            p('Обдув', 'все направления'),
        ],
        shots: ['панель климата'],
    },
    leaks_warm: {
        title: 'Подтёки',
        hint: 'мотор прогрет — загляните под машину',
        instruction: [
            p('Мотор снизу', 'свежее масло'),
            p('Коробка', 'подтёки, запах'),
            p('Радиатор и шланги', 'антифриз'),
        ],
        shots: ['под мотором'],
    },
    dipstick_cap: {
        title: 'Щуп и крышка',
        hint: 'мотор заглушен 2–3 минуты',
        instruction: [
            p('Щуп', 'уровень и цвет масла'),
            p('Крышка горловины', 'эмульсия, налёт'),
            p('Запах', 'гарь'),
        ],
        shots: ['щуп', 'крышка горловины'],
    },
    engine_running: {
        title: 'Работа',
        hint: 'мотор прогрет, капот открыт',
        say: 'Попросите продавца погазовать и включить передачи. Снимайте 30 с',
        instruction: [
            p('Холостой ход', 'стук, вибрации'),
            p('Передачи', 'толчки, задержки'),
            p('Лампы', 'ничего не загорелось'),
        ],
    },
    battery: {
        title: 'АКБ',
        hint: 'клеммы и дата на корпусе',
        instruction: [
            p('Клеммы', 'окислы, налёт'),
            p('Дата выпуска', 'возраст батареи'),
            p('Корпус', 'вздутие, подтёки'),
        ],
        shots: ['аккумулятор'],
    },
    diagnostics_files: {
        title: 'Диагностика и файлы',
        hint: 'необязательно — без файлов в отчёте будет «диагностика не проводилась»',
        instruction: [
            p('Сканер OBD', 'PDF или скриншот отчёта'),
            p('Проверки по базам', 'залоги, розыск, история'),
            p('Прочее', 'любой файл с подписью'),
        ],
    },
};
//# sourceMappingURL=labels.ru.steps.js.map